export default __webpack_public_path__ + "static/media/Mark-2-Suit-12.5e839935.jpg";